export default __webpack_public_path__ + "guide--vector-tiles-standards-ccw-960-ad73400527dbe6ad34565ae8f15e235f.png";